// @ts-strict-ignore
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  HostListener,
  NgZone,
  OnInit
} from '@angular/core';
import { LMColumnsBaseComponent } from './lm-columns-base.component';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMLayoutUtilDirective } from './lm-layout-util.directive';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMLoggerService } from '@app/services';

@Component({
  selector: 'lm-columns-percent',
  templateUrl: 'lm-columns-percent.component.html',
  styleUrls: [ 'lm-columns-percent.component.scss' ],
  providers: [ LMLayoutUtilDirective, LMFormLayoutService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMColumnsPercentComponent extends LMColumnsBaseComponent implements OnInit, AfterViewInit {

  @HostBinding('style.width.px') hostWidth: string;
  @HostListener('window:resize') onResize() {
    this.setHostWidth();
  }

  constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService,
    protected changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private lmLayoutUtil: LMLayoutUtilDirective
  ) {
    super(lmConditionUtilService, lmFormLayoutService, lmLoggerService, changeDetectorRef);
  }

  ngOnInit() {
    // Set columns for template
    if (this.layoutObject.nbrColumns > 1 && this.layoutObject.columns.length === 1) {
      this.columns = this.lmFormLayoutService.buildImplicitColumns(this.layoutObject, this.model);
    } else {
      this.layoutObject.columns.forEach((column, i) => {
        column.index = i;
      });
      this.columns = this.layoutObject.columns;
    }
  }

  ngAfterViewInit() {
    // Sets width of table on initial load
    // Add horizontal scroll to table if viewport is to small
    this.ngZone.runOutsideAngular( () => {
      setTimeout(() => {
        this.setHostWidth();
      }, 1);
    });
  }

  private setHostWidth() {
    if (this.parentIsModal) {
      return;
    }

    this.hostWidth = this.lmLayoutUtil.getParentWidth();
  }
}
